import React, { useState } from "react";
import api from "../../../api/api";
import formatIntWithCommas from "../../../util/formatIntWithCommas";
import { useQuery } from "react-query";

interface ChartData {
  _id: string;
  totalRevenue: number;
}

function useChartSelector() {
  const [totalAccepted, setTotalAccepted] = useState(0);
  const [totalAwaiting, setTotalAwaiting] = useState(0);

  const { isFetching, isError } = useQuery(
    "ChartRevenue",
    async () => {
      const res = await api.get("/api/fetchAllForChart");

      let tAccept = 0;
      let tAwait = 0;

      res.data.forEach((q: ChartData) => {
        if (q.totalRevenue && q._id !== "Archived") {
          q._id === "Quote"
            ? (tAwait += q.totalRevenue)
            : (tAccept += q.totalRevenue);
        }
      });

      setTotalAccepted(Math.round(tAccept));
      setTotalAwaiting(Math.round(tAwait));
    },
    { refetchOnWindowFocus: false }
  );

  const acceptedWithComma = formatIntWithCommas(totalAccepted);

  const awaitingWithComma = formatIntWithCommas(totalAwaiting);

  return {
    totalAccepted,
    totalAwaiting,
    isFetching,
    isError,
    acceptedWithComma,
    awaitingWithComma,
  };
}

export default useChartSelector;
